<template>
    <b-modal ref="modal" v-bind="$attrs" :id="id" :title="modalTitle" @ok="handleOk" title-class="font-18">
      <component
        :is="form"
        v-bind="formProps"
        v-on="formListeners"
        v-model="model"
        :is-valid.sync="isValid"
        :errors="errors"
        ref="form"
        is-modal="true"
      >
      </component>
      <template #modal-footer="{ ok, cancel}">
        <b-button size="md" variant="outline-dark" @click="cancel()">
          Batal
        </b-button>
        <b-button size="md" variant="primary" @click="ok()" :disabled="updating">
          <i v-if="updating" class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
          Simpan
        </b-button>
      </template>
    </b-modal>
  </template>
  
  <script>
  import FormsModel from "@/components/forms/model";
  import Swal from "sweetalert2";
  
  export default {
    name: "modal-edit",
    props: {
      id: {type: String, required: true},
      modalTitle: {default() { return this.lodash.startCase(this.$t('models.singular')) }},
      resourceRoute: {default: 'models'},
      modelVariable: {default: 'model'},
      form: {
        type: Object, default: function() {
          return FormsModel;
        }
      },
      formProps: {
        type: Object, default: function () {
          return {}
        }
      },
      formListeners: {
        type: Object, default: function () {
          return {}
        }
      },
      initialValue: {type: Object, default() { return {} }}
    },
    data() {
      return {
        loading: false,
        isValid: true,
        updating: false,
        model: {
          ...this.initialValue
        },
        errors: {}
      }
    },
    mounted() {
      // if (this.getModelKey(this.model))
      // this.fetchModel()
    },
    watch: {
      'initialValue.type': function (n, o) {
        if (!this.lodash.isEqual(n,o)) {
          this.model.type = n
        }
      }
    },
    methods: {
      getModelKey() {
        return this.model[this.modelKey || 'id'];
      },
      getModelName() {
        return this.model['name'] || this.getModelKey();
      },
      handleModelChanged(event){
        this.isEditing = event;
      },
      handleBack() {
        this.$refs.modal.hide()
      },
      failedAlert(error) {
        if (error.response && error.response.status === 422) {
          this.errors = (error.response.data || {}).errors || {};
          const key = Object.keys(this.errors).find((k) => this.errors[k].length)
          const errorMessage = key && this.errors[key][0]
          return Swal.fire({
            title: this.$t('Failed') + '!',
            text: errorMessage || (error.response && (error.response.data || {}).message) || error.message,
            type: 'danger',
            confirmButtonClass: 'btn btn-danger btn-fill',
            buttonsStyling: false
          })
        }
        return Swal.fire({
          title: this.$t('Failed') + '!',
          text: (error.response && (error.response.data || {}).message) || error.message,
          type: 'danger',
          confirmButtonClass: 'btn btn-danger btn-fill',
          buttonsStyling: false
        })
      },
      updateSuccessAlert(something) {
        return Swal.fire({
          title: this.$t('Success') + '!',
          text: this.$t(`You've updated {something}`, {something}),
          type: 'success',
          showConfirmButton: false,
          timer: 1500
        })
      },
      update(value) {
        return Promise.resolve({ data: value })
      },
      fetchModel(){
        
      },
      handleUpdate(value) {
        this.updating = true;
        this.update(value)
          .then(() => this.updateSuccessAlert(this.getModelName()))
          .then(() => {
            this.isEditing = false;
            this.$emit('updated', value);
            return this.handleBack();
          })
          .catch((error) => this.failedAlert(error))
          .finally(() => { this.updating = false; });
      },
      deleteConfirmAlert() {
        return Swal.fire({
          title: this.$t('Are you sure?'),
          text: this.$t(`You won't be able to revert this!`),
          type: 'warning',
          showCancelButton: true,
          confirmButtonClass: 'btn btn-success btn-fill mx-1',
          cancelButtonClass: 'btn btn-danger btn-fill mx-1',
          confirmButtonText: this.$t('Yes, delete it!'),
          cancelButtonText: this.$t('Cancel'),
          buttonsStyling: false
        })
      },
      deleteSuccessAlert(something) {
        return Swal.fire({
          title: this.$t('Deleted') + '!',
          text: this.$t(`You deleted {something}`, {something}),
          type: 'success',
          confirmButtonClass: 'btn btn-success btn-fill',
          buttonsStyling: false
        })
      },
      delete() {
        return Promise.resolve({ data: {} })
      },
      handleDelete() {
        this.deleteConfirmAlert().then(result => {
          if (result.value) {
            this.deleting = true;
            this.delete()
              .then(() => this.deleteSuccessAlert(this.getModelName()))
              .then(() => this.handleBack())
              .catch((error) => this.failedAlert(error))
              .finally(() => { this.deleting = false; });
          }
        });
      },
      preventNav() {
        if (this.isEditing) {
          return this.$t("All unsaved data will be lost. Are you sure?");
        }
        return null
      },
      edit(id){
        this.fetchModel(id);
        this.$bvModal.show(this.id)
      },
      handleOk(event) {
        event.preventDefault()
        if (!('validateAll' in this.$refs.form)) return;
        this.$refs.form.validateAll().then((isValid) => {
          this.isValid = isValid
          if (isValid) this.$nextTick(() => {
            this.handleUpdate(this.model)
          })
        })
      }
    },
  }
  </script>
  